import React from 'react';
import SimuladorCreditoEmpreendimentoParametroService from '../../../../lib/api/simuladorCreditoEmpreendimentoParametro/simuladorCreditoEmpreendimentoParametroService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class SimuladorCreditoEmpreendimentoParametro extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelSimuladorCreditoEmpreendimentoParametro()
    {
        return SimuladorCreditoEmpreendimentoParametroService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return SimuladorCreditoEmpreendimentoParametroService.enviarParametrosAoEventGrid();
    }

    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelSimuladorCreditoEmpreendimentoParametro}
                enviarExcelParametros={SimuladorCreditoEmpreendimentoParametroService.enviarExcelParametros}
                deletarExcelParametros={SimuladorCreditoEmpreendimentoParametroService.deletarExcelParametros}
                nomeDoArquivo='Parametro Simulador'
            ></TemplateParametro>
        );
    }
}

export default SimuladorCreditoEmpreendimentoParametro